export function getLocale() {
  // RFC 4646 (言語タグの形式に関する標準) に定められた「言語コード-国コード」(例: ja-JP)の形式で提供されるため、ほとんどの現代のブラウザで有効
  const browserLanguage = navigator.language.split("-")[0]
  // 日本語以外は英語
  return browserLanguage == "ja" ? browserLanguage : "en"
}
